module.exports = __webpack_public_path__ + "img/chinesecompany190.defcf71c.png";